module.exports = __webpack_public_path__ + "img/chang-tien-wei-4.679d52f6.jpg";